import { CaptureCountlyEvents, CaptureCountlyEventsContext } from 'epion-checkin/context/capture-countly-events';
import { useContext } from 'react';

const useCountly = (): CaptureCountlyEvents => {
    const context = useContext(CaptureCountlyEventsContext);

    if (context === undefined) {
        throw new Error('useCountly must be used within a CaptureCountlyEventsContextProvider');
    }

    return context;
};

export { useCountly };
